import { ServiceHistoryFilter } from '../models';
import { Table } from '@/components';
import { useMemo } from 'react';
import { useServiceHistory, useServiceHistoryPagination } from '../hooks';
import { serviceHistoryTableColumns } from '../config';

import styles from './ServiceHistoryTable.module.css';

type ServiceHistoryTableProps = {
  serviceHistoryFilter?: ServiceHistoryFilter;
};

const ServiceHistoryTable = ({
  serviceHistoryFilter,
}: ServiceHistoryTableProps) => {
  const columns = useMemo(() => serviceHistoryTableColumns, []);

  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    useServiceHistoryPagination();

  const { serviceHistory, isServiceHistoryLoading, totalItems, totalPages } =
    useServiceHistory({
      paginated: {
        page: currentPage,
        pageSize: pageSize,
      },
      filters: serviceHistoryFilter,
    });

  return (
    <div className={styles.content}>
      {serviceHistory?.length > 0 ? (
        <Table
          columns={columns}
          data={serviceHistory}
          isLoading={isServiceHistoryLoading}
          pagination={{
            totalItems,
            totalPages,
            currentPage,
            rowsPerPage: pageSize,
            onPageChange: handlePageChange,
            onRowsPerPageChange: handlePageSizeChange,
          }}
        />
      ) : (
        'No hay registros por el momento'
      )}
    </div>
  );
};

export default ServiceHistoryTable;
